import { createFileRoute } from '@tanstack/react-router';

import { RouteGuard } from '../../lib/route-guard.js';

export const Route = createFileRoute('/users')({
  component: () => <RouteGuard route="/users" />,
});
